import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
// import * as Icon from 'react-bootstrap-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { HashLink } from 'react-router-hash-link';
import '../css/answers.css';

function SouthProp({ targetDivs, divId }) {
  const [isShown, setIsShown] = useState(false);

  const ShowDiv = () => {
    setIsShown(!isShown);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div onClick={ShowDiv}>
        <p
          style={{
            textAlign: 'left',
            marginLeft: '15px',
            paddingLeft: '10px',
            marginBottom: 1,
            color: 'blue',
          }}
        >
          <HashLink smooth to="#answerId" style={{ paddingRight: 10 }}>
            {targetDivs.quest}
            {'  '}
          </HashLink>

          {isShown ? (
            <FontAwesomeIcon icon={faAngleUp} size={48} color="gray" />
          ) : (
            <FontAwesomeIcon icon={faAngleDown} size={48} color="gray" />
          )}
        </p>
      </div>

      {isShown && (
        <div id="answerId" className={`answersDiv ${isShown ? 'open' : ''}`}>
          <p>{targetDivs.answer}</p>
        </div>
      )}
    </div>
  );
}

export default SouthProp;
